import React from 'react';
import { getPublicRental } from "../../../data/loca/rentals";
import { advancePaymentCall } from "../../../data/loca/sumup";
import { calendarStrings } from '../../../services/calendarStrings';

import {
    useLoaderData
} from "react-router-dom";

import Moment from 'react-moment';
import 'moment/locale/fr';
import { default as SumupCard } from "../../../routes/modules/SumupCard";

export async function loader({ params }) {

    const rental = await getPublicRental(params.rentalId);

    let resp = await advancePaymentCall(params.rentalId);
    var error = resp.error;
    
    var Status = resp.status;
    var SumUpCheckoutId = resp.sumUpCheckoutId;

   
    return { Status, rental, error, SumUpCheckoutId, rentalId: params.rentalId };
}


export default function StripePayment() {
    const { Status, rental, error, SumUpCheckoutId } = useLoaderData();
    const formatEuroAmount = (amount) => Number(amount ?? 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const requiresSignature = rental?.signatureRequired;

    return (
        <div className="financialForm">
            <div id="thumbnail">
                <img className="depositImg" height="192" key={rental.publicId} alt={rental.name} src={rental.base64Picture || null} />


                <div>
                    <h1>Location : {rental.name}</h1>

                  
                    <div id="thumbnail-form">
                        <label>Par :&nbsp;<b>{rental.clientFirstname} {rental.clientLastname}</b></label> ({rental.serviceName})
                        
                    </div>
                    <label>
                    Date :&nbsp;
                        <Moment locale="fr" calendar={calendarStrings}>
                            {new Date(rental.startDate)}
                        </Moment>
                        &nbsp;jusqu'&agrave;&nbsp;
                        <Moment locale="fr" calendar={calendarStrings}>
                            {new Date(rental.endDate)}
                        </Moment>

                    </label>

                    {Status === "Error" ? (
                        <h3>
                            {error}
                        </h3>
                    )
                        : (
                            <>
                        
                    <div className="contentForm"></div>
                    

                    {Status === "Created" ? (
                        <>
                            <h2>Je paie mon acompte par carte</h2>
                            <p>Montant  : {formatEuroAmount(rental.advancePaymentAmount)}€</p>
                            <SumupCard checkoutId={SumUpCheckoutId} />

                        </>
                    ) 
                        : (
                            <>
                                <h2>Paiement effectué avec succès !</h2>
                                {requiresSignature && (
                                    <p>Signature électronique nécessaire pour finaliser la location.</p>
                                )}
                            </>
                        )}

                            </>
                        )}
                </div>
            </div>
        </div>
    )            
}
